/**
 * Material Testing field formatter
 */

import {useIsTestBooked} from '@hconnect/tuc-processes/fields'
import {useChangeableField} from '@hconnect/tuc-processes/orderManagement/orderChange'

import type {FieldFormatter, FieldFormatterResult} from './types'

export const useMaterialTestingFormatter = (): FieldFormatter => {
  const {isTestBooked, defaultIsTestBooked} = useIsTestBooked()
  const testingState = useChangeableField('isTestBooked')

  return (context) => {
    const {t} = context
    const requiresApproval = testingState.state === 'requireDispatchConfirmation'
    const hasChanges = testingState.isDirty

    const oldValue = defaultIsTestBooked
      ? t('orderIntake.rmc.steps.shared.materialTesting.yes', 'Yes')
      : t('orderIntake.rmc.steps.shared.materialTesting.no', 'No')
    const newValue = isTestBooked
      ? t('orderIntake.rmc.steps.shared.materialTesting.yes', 'Yes')
      : t('orderIntake.rmc.steps.shared.materialTesting.no', 'No')

    const values: FieldFormatterResult['values'] = []
    if (hasChanges && oldValue !== newValue) {
      values.push({text: oldValue, isDiscarded: true, isNew: false})
    }
    values.push({text: newValue, isDiscarded: false, isNew: hasChanges})

    return {values, requiresApproval, hasChanges}
  }
}
